import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use ChannelType from application-types instead.
 */
export class ChannelType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Channel';

  friendlyName = 'Channel';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  superUserOnly = false;

  get example() {
    return {
      _id: '6DWOG3vwr3kzrCWXvECMiP',
    };
  }

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Channel from application-types instead.
 */
const definition = new ChannelType();

Types.addBaseType(definition);

export default definition;
